export default {
    route: {
        Index: '首页',
        App_Type_Design: '应用类型设计',
        App_Manage: '应用管理',
        Flow_List: '流程列表',
        Form_Type_Design: '表单类型设计',
        companyName: '公司名称',
        auth_character: '权限角色',
        order_detail: '订单详情',
        auth: '权限管理',
        check_start: '启动订单审批',
        character_type: '角色类型',
        character: '角色管理',
        codeList: '基础代码管理',
        log_manage: '日志管理',
        opt_log: '操作日志',
        search_log: '日志检索',
        menu_manage: '菜单管理',
        source_manage: '资源管理',
        app_management: '应用管理',
        org_people: '组织人员',
        org_str: '组织结构',
        people_manage: '人员管理',
        work_bench: '工作台',
        config: '工作台设置',
        password: '密码强度',
        annex_manage: '附件类型管理',
        company_manage: '企业管理',
        company_index: "企业索引信息",
        company_app: '企业应用管理',
        company_detail_info: "企业详细信息",
        app_role_per_config: '应用角色人员配置',
        basic_info: "基本信息",
        people_info: '人员信息',
        auth_management: '权限管理',
        data_dic: "数据字典",
        database_address: "数据库地址",
        menu_management: '菜单管理',
        resource_management: '资源管理',
        role_auth: '角色权限',
        secret_allot: '秘钥分发',
        server_address: '服务地址配置',
        super_account: '超级账户管理',
        system_management: '系统管理',
        org_human_demo: '组织人员demo',
        people_basic_info: '人员基本信息',
        app_support: '应用支撑平台',
        app_select: '应用选择页面',
        process_management: '流程管理',
        process_type_management: '流程分类管理',
        process_list_management: '流程列表管理',
        process_template: '模板管理',
        process_template_type: '模板类型管理',
        bussiness_data_dic: '电商数据字典',
        flow_modal: '电商流程模板',
        item_index: '商品目录',
        item_code: '商品编码',
        item_manage: '商品管理',
        agreement_manage: '协议管理',
        bussiness_check_config: '电商审批流程配置',
        bussiness_check_edit: '电商审批流程编辑',
        bussiness_purchase_config: '电商采买权限配置',
        bussiness_people_config: '电商角色人员配置',
        detail_agreement: '协议详情',
        edit_agreement: '编辑协议',
        cart: '购物车',
        bussiness_manage: '电商管理',
        apply_purchase: '采购申请',
        my_apply: '我的申请',
        purchase_apply: '申请采买',
        order_manage: '订单管理',
        my_order: '我的订单',
        check_order: '订单审批',
        check_list: '审批订单列表',
        bill_manage: '账票管理',
        my_bill: '我的账票',
        bills: '集中账票',
        analyze: '统计分析',
        item_detail: '商品详情',
        item_order: '商品下单',
        select_item: '选择商品',
        apply_list: '需采申请列表',
    },
    login: {
        title: '系统登录',
        logIn: '登录',
        username: '账号',
        password: '密码',
    },
    button: {
        confirm: '确定',
        cancel: '取消',
        edit: '编辑',
        add: '新增',
        createRole: '创建角色名称',
        search: '搜索',
        delete: '删除',
        deleteSelected: '删除所选',
        code: '代码',
        distribution: '分配',
        detail: '详情',
        enable: '激活',
        disable: '禁止',
        save: '保存',
        search_child: '是否搜索下属所有组织',
        move: '移动',
        batch: '批量',
        create: '创建',
        enterprise: '企业',
        reset: '管理员密码重置',
        p_reset: '密码重置',
        _reset: '重置',
        select_branch: '选择部门',
        save_back: '保存返回列表',
        continune: '保存增加',
        all: '全部',
        other: '其他',
        close: '关闭',
        imports: '批量导入',
        exports: '批量导出',
        download: '下载模版',
        success: '成功',
        cart: '购物车',
        mulit: '多选',
        more: '更多',
        newAddPermission: '新建权限',
        createApp: '创建新应用',
        retrieval: '检索',
        addtrip: '添加行程',
        save_submit: '保存并提交',
        continune_add: '继续添加',
        viewFlight: '查看航班'
    },
    table: {
        fatherType: '父类型',
        typeName: '类型名称',
        typeId: '类型ID',
        formTypeName: '表单类型名称',
        opt: '操作',
        appName: '应用名',
        appId: '应用Id',
        fatherApp: '父应用',
        des: '描述',
        status: '状态',
        name: '名称'
    },
    title: {
        title: '赛鼎'
    },
    org: {
        org_name: '组织名',
        org_id: '组织ID',
        org_people: '组织人员',
        father_id: '父组织ID',
        index: '序号',
        org_short: '简称',
        org_type: '组织类型',
        group_company: '集团公司',
        child: '子公司',
        org: '组织',
        virtual: '虚拟目录',
        org_basic: '组织基本信息',
        org_extend: '组织扩展信息',
        org_account: '组织账户信息',
        room_number: '房间号',
        fax: '传真',
        postal_address: '通讯地址',
        tel: '座机号',
        company_name: '公司名',
        tax: '税号',
        deposit_bank: '开户银行',
        account: '银行账户',
        company_address: '公司地址',
        allowed_invoice: '可开发票类型',
        prefer_invoice: '优先发票类型',
        vat_special_invoice: '增值税专用发票',
        vat_normal_invoice: '增值税普通发票',
        platform: '平台组织架构',
        xz: '行政组织架构'
    },
    people: {
        name: '姓名',
        sex: '性别',
        people_name: '人员姓名',
        people_number: '人员编号',
        mobile: '手机',
        position: '职位',
        telnumber: '电话',
        select_org: '选择组织',
        select_people: '选择人员',
        select_character: '选择角色',
        account_info: '账户信息',
        base_info: '基本信息',
        extend_info: '扩展信息',
        account: '账户',
        password: '密码',
        checktype: '验证方式',
        keyinfo: 'Key 信息',
        account_type: '账户类型',
        account_secure: '账户安全状态',
        account_expire: '有效期',
        status: '状态',
        xiagang_status: '下岗状态',
        uuid: 'UUID',
        en_name: '英文名',
        cn_name: '中文名',
        birthday: '生日',
        email: '电子邮件',
        ID: 'ID',
        character: '角色',
        avatar: '头像',
        default_password: '不填则默认密码为123456',
        on_position: '在岗',
        off_position: '下岗',
        male: '男',
        female: '女',
        shenfen: '身份证号'
    },
    auth: {
        permissionName: '权限名称',
        permissionID: '权限ID',
        allocationOfresources: '分配资源',
        newpermissionInfo: '新增权限名称',
        accesscode: '权限代码',
        higherauthority: '上级权限',
        permissioninfo: '权限信息',
        resourceid: '资源 ID',
        resourcename: '资源名称'
    },
    company: {
        title: '企业管理',
        enterprise: '企业',
        enterprisenum: '企业号',
        corporatelogo: '企业 Logo',
        enterprisename: '企业名称',
        enterprisejc: '企业简称',
        enterprisealias: '企业代号',
        enterprisetel: '企业电话',
        enterprise_character: '企业角色',
        enterprise_type: '企业类型',
        text1: '将文件拖到此处，或',
        text2: '点击上传',
        tip1: '支持jpg、jpeg、png、bmp格式',
        tip2: '图片小于5M（尺寸80*80像素），超过此尺寸会被压缩并降低质量',
        tip3: '字数限制30字符',
        tip4: '注：系统上显示简称',
        manage_company: '管理公司',
        done_company: '执行公司',
        parent: '上级公司',
        in_out: '内部/外部',
        password: '密码',
        newpassword: '新密码',
        admin_account: '管理员帐户',
        staff: '员工'
    },
    character: {
        characterName: '角色名称',
        characterType: '角色类型',
        characterID: '角色ID',
        adminType: '平台管理员类',
        systemType: '企业管理员',
        characterstate: '状态',
        belonger: '所属组织',
        checkTheStaff: '查看人员',
        assignpermissions: '分配权限',
        assignfrompermissions: '分配表单权限',
        personlist: '人员列表',
        roleinfo: '角色信息',
        select: '请选择',
        staffname: '人员名称',
        staffid: '人员ID',
        belongerbumen: '所属部门',
        formname: '表单名称',
        formid: '表单ID',
        toview: '查看',
        modify: '修改 ',
        increase: '增加',
        delete: '删除',
        belongComType: '所属公司类型',
        belongApp: '所属应用',
        roleDes: '角色描述',
        sub_department: '兼职部门'
    },
    character_type: {
        character_typeName: '角色类型名称',
        character_typeID: '角色类型ID',
        character_typeinfo: '角色类型信息',
        character_types: '角色类型分类',
        character_typesdesc: '角色类型描述',
        keywords: '关键词'
    },
    index: {
        daiban: '代办',
        yiban: '已办',
        shenhe: '审核',
        chakan: '查看'
    },
    menu: {
        xuhao: '序号',
        menuID: '菜单代码',
        fatherMenu: '上级菜单',
        menuName: '菜单名称',
        menuType: '菜单类型',
        parentMenu: '父菜单',
        menuIcon: '图标',
        appName: '应用名称',
        menuState: '状态',
        menuSort: '排序',
        menuParentId: '菜单父id',
        appId: '应用id',
        fatherApp: '所属应用',
        menuAddrType: '菜单地址类型',
        openMode: '打开方式',
        selMenuAddrType: '选择菜单地址类型',
        systemAddr: '系统地址',
        innerAddr: '内部地址',
        outerAddr: '外部地址',
        formAddr: '表单',
        menuAddr: '请求地址',
        menuAuth: '菜单权限',
        sourceCode: '资源代码',
        authCode: '权限代码',
        formAuth: '表单权限',
        yes: '是',
        no: '否',
        chooseOpenMode: '选择打开方式',
        default: '默认',
        newPage: '新页面',
        assignPosition: '指定位置',
        moveMenu: '移动表单',
        addMenu: '添加表单',
        editMenu: '编辑表单',
        move: '移动',
        disable: '禁用',
        enable: '启用',
        res: '资源'
    },
    log: {
        startDate: '开始日期',
        endDate: '结束日期',
        to: '至',
        logDate: '日期',
        userName: '用户姓名',
        userIP: '用户IP',
        optContent: '操作内容',
        optNodeID: '操作节点ID',
        optNodeIP: '操作节点IP',
        compData: '完整数据',
        optType: '操作类型'
    },
    source: {
        sourceCode: '资源代码',
        sourceDesc: '资源描述',
        sourceAddr: '资源地址',
        needAuth: '是否需要权限验证',
        needLogin: '是否需要登录',
        appType: '应用类型',
        parentModule: '所属模块',
        sourceId: '资源id',
        isMenu: '是否是菜单',
        sourceName: '资源名称',
    },
    code: {
        xuhao: '序号',
        codeTypeID: '类型ID',
        codeTypeName: '类型名称',
        codeTypeClassify: '类型分类',
        codeStandard: '遵循标准',
        codeTypeDescribe: '类型描述',
        opt: '操作',
        codeManage: '代码管理',
        codeState: '状态',
        codeName: '代码名称',
        codeValue: '代码值',
        supCode: '上级代码',
        codeSubname: '子名称',
        codeShortName: '代码简称',
        codeAbbreviations: '简拼码',
        codeFullSpell: '全拼码',
        codeExpand: '扩展码'
    },
    annex: {
        uploadtype: '上传分类',
        filetype: '文件类型',
        dir_split_code: '目录拆分方式',
        file_nums_code: '允许文件数量',
        file_path: '文件存储位置',
        file_size: '文件大小',
        save_type: '存储类型',
        type_desc: '分类说明'

    },
    valid: {
        required: '此项为必填',
        length: '总长度为:'
    },
    dic: {
        dic_code: '字典代码',
        dic_name: '字典名称',
        dic_type: '代码类型',
        parent: '上级代码',
        app: '对应应用',
        create_dic: '创建字典'
    },
    appMange: {
        appName: '应用名称',
        appState: '应用状态',
        operate: '操作',
        startUse: '启用',
        noUse: '禁用'

    },
    resource: {
        sourceCode: '资源代码',
        sourceDesc: '资源描述',
        sourceAddr: '资源地址',
        needAuth: '是否需要权限验证',
        needLogin: '是否需要登录',
        appType: '应用类型',
        parentModule: '所属模块',
        sourceId: '资源id',
        isMenu: '是否菜单',
        sourceName: '资源名称',
    },
    item: {
        search_text: '检索内容',
        label: '商品名称',
        uid: '商品编号',
        code: '商品编码',
        type: '商品类型',
        child_node: '下级节点',
        sibling_node: '平级节点',
        sure: '确定删除吗？',
        add_code: '添加商品编码',
        disable_code: '批量禁用编码',
        unit: '单位',
        level_1: '一级分类',
        level_2: '二级分类',
        level_3: '三级分类',
        add_edit_code: '添加/编辑商品编码'
    },
    agree: {
        code: '协议编号',
        supply_name: '供应商名称',
        code_name: '协议名称',
        status: '状态',
        time: '时间区间',
        to: '至',
        agree: '协议',
        supply: '供应商',
        name: '名称',
        person: '签订人',
        agree_time: '签订时间',
        add_agree: '新建框架协议',
        print: '打印框架协议',
        "new": "新建",
        "outdate": "过期",
        "effective": "有效",
        performing: '生效',
        dialog_title: '添加/编辑商品',
        item_index: "平台商品目录",
        index_name: '平台商品目录名称',
        supply_index: '供应商商品目录',
        supply_index_name: '平台目录名称',
        discount: '折扣',
        start: '启动流程',
        sign_time: '签订日期',
        expire: '有效日期',
        add_index: '添加目录',
        del_index: '删除目录',
        _import: '导入清单',
        _export: '导出清单',
        upload: '上传附件',
        check_upload: '查看附件',
        protocol_state: '协议状态'
    },
    bussiness: {
        nearly: '最近加入的商品',
        filtered: '已筛选',
        band: '品牌',
        keyword: '关键字',
        sort: '筛序',
        price: '价格',
        by_supply: '按供应商分列显示',
        by_sold: '按销量整体排序',
        by_price: '按价格整体排序',
        solded: '销量',
        index: '首页',
        allDis: '全部分类',
        join_cart: '加入购物车',
        purchase: '立即购买',
        supplier_code: '供应商商品编码',
        contactor: '联系人',
        telphone: '联系电话',
        supply_area: '所在地区',
        like_hot: '同类热卖',
        item_detail: '商品详情',
        item_size: '商品规格',
        item_estimation: '商品评价',
        good_rate: '好评率'
    },
    cart: {
        item_info: '商品信息',
        per_price: '单价',
        number: '数量',
        price: '金额(元)',
        selected: '已选商品',
        sum: '合计(不含运费)：',
        generateOrder: '生成订单',
        _selected: '已选择',
        unit_item: '件商品',
        selectAll: "全选",
        sumed: '总计',
        continune: '继续购物'
    },
    order: {
        apply: '申请单',
        theme: '订单编号',
        time: '时间区间',
        name: '商品名称',
        order_code: '订单号',
        order_data: '下单日期',
        size: '规格',
        question: '售前咨询',
        include_tran: '含运费',
        total_fee: '总额',
        _new: '新创建',
        submit_third: '提交到第三方',
        examining: '审批中',
        exmined: '已审批',
        prepare_pay: '待付款',
        prepare_send: '待发货',
        prepare_estimate: '待评价',
        purchase_company: '采购企业',
        order_detail: '订单详情',
        confirm: '提交审批',
        undo: '撤回审批',
        check: '提交审批',
        approval: '审批',
        cancel: '取消订单',
        to_pay: '待付款',
        item_info: '商品信息',
        single_price: '单价',
        number: '数量',
        price: '金额',
        status: '状态',
        order_type: '采购方式',
        item_quality: '商品质量',
        box_quality: '包装质量',
        express_speed: '配送速度',
        service_quality: '配送服务态度',
        estimate_content: '评价内容',
        order_status: '订单状态',
        buyer: '下单人',
        purchaser: '采购人',
        position: '所在部门',
        third_code: '第三方订单号',
        need_department: '需求部门',
        purchase_department: '采购部门',
        submit_order: '新建订单',
        check_finish: '审批完成',
        pay_success: '支付成功',
        out_warehouse: '商品出库',
        wait_receive: '确认收货',
        finish: '完成',
        refuse: '拒绝收货',
        refund: '申请退款',
        receiver_info: '收货人信息',
        pay_info: '付款信息',
        invoice_info: '发票信息',
        receiver: '收货人',
        address: '地址',
        mobile: '手机号码',
        pay_method: '付款方式',
        pay_time: '付款时间',
        order_total: '订单总额',
        invoice_type: '发票类型',
        invoice_header: '发票抬头',
        invoice_content: '发票内容',
        download_invoice: '下载电子发票',
        sellremark: '售后备注'
    },
    bills: {
        all_bills: '全部账单',
        unticketed_bill: '未开票账单',
        unreconciled: "未核对账单",
        unpayed: '未还款账单',
        supply: '供应商',
        time: '账期',
        status_k: '开票状态',
        status_h: '还款状态',
        status_d: '对账状态',
        code: '账单编号',
        purchase_company: '采购单位',
        date_c: '出账日期',
        total_bill: '账单总额',
        confirm_reconcil: '确认对账',
        apply: '申请开票',
        confirm_get: '确认收票',
        check: '查看发票',
        pay: '还款',
        normal: '普通发票',
        electri: '普通电子发票',
        zeng: '增值税专用发票',
        ticker_type: '开票方式',
        ticker_head: '发票抬头',
        taxer_code: '纳税人识别号',
        ticker_content: '发票内容',
        focus_ticket: '集中开票',
        person: '个人',
        zhouqi: '记账周期',
        mobile: '收票人手机',
        email: '收票人邮箱',
        ticket_info: '开票信息',
        name: '名称',
        company_address: '单位地址',
        telphone: '电话号码',
        bank: '开户银行',
        account: '银行账号'
    },
    app_role_config: {
        appName: '应用名称',
        roleName: '角色名称',
        roleDesc: '角色描述',
        per: '人员',
        operate: '操作'
    },
    b_flow_config: {
        progName: '流程名称',
        progType: '流程类型',
        progDes: '流程说明',
        progStatus: '状态',
        progOper: '操作'
    },
    page: {
        prevStep: '上一步',
        nextStep: '下一步'

    },
    business: {
        first: '一级目录',
        second: '二级目录',
        third: '三级目录',
        department: '权限部门',
        director: '主管部门',
        focus: '配置为集中',
        autonomy: '配置为自主',
        project: '配置为项目部采购',
        purchasing: '集中采购',
        myself: '自主采买',
        depart: '权限部门',
        buy: '项目自主采买'
    },
    travel: {
        applyBook: '申请预定',
        directBook: '直接预定',
        info_number: '信息单编号',
        apply_person: '出行人',
        apply_reason: '事由',
        apply_date: '申请日期',
        departure_date: '出发日期',
        departure_address: '出发地',
        destination_address: '目的地',
        order_type: '订单类型',
        order_code: '订单编号',
        order_create_time: '生成日期',
        ticket_code: '票号',
        user_name: '出行人',
        out_type: '出行方式',
        flight_code: '航班号/车次',
        set_out_time: '出发时间',
        flight_price: '价格',
        code_status: '状态',
        check_in: '值机',
        return_ticket: '退票',
        endorse: '改签',
        change_date: '改期',

        // 商旅人事
        personnel_name: '姓名',
        personnel_account: '员工编号',
        standardId: '差标级别',
        auth_person: '授权人',
        bulk_operation: '批量操作',
        sync_ctrip_person: '同步携程人事',
        keyword_department: '部门关键字',
        all_peosonList: '全部',
        has_configed: '已配置',
        no_configed: '未配置',
        department: '部室',
        subaccount_name: '子账户名称',
        is_config: '是否配置',
        is_sych: '是否同步',
        has_sych: '已同步',
        no_sych: '未同步',
        have_left: '已离职',
        on_job: '在职',
        operate: '操作',
        go_config: '配置',
        edit_config: '修改配置',
        travel_person_info: '商旅人员信息',
        basic_info: '基本信息',
        xc_card: '携程卡号',
        id_card: '身份证号',
        mobile_phone: '手机号码',
        email: '邮箱',
        passport: '证照名',
        passportNo: '证照号码',
        passportDate: '证照起止日期',
        travel_info: '商旅信息',
        auth_pwd: '授权密码',
        select_date: '选择日期',
        person_gender: '性别',
        // 商旅子账户
        sonAccountName: '子账户名称',
        sonAccountNum: '子账户编码',
        sonAccountDes: '描述',
        sonAccountState: '状态',
        sonAccountAdd: '新增',
        sonCompanyName: '公司名称',
    }
}